import React from "react"
import { TabsSeeker } from "@ui-seeker/core"

import { dsColorNew } from "@palette"


// The tabs of a page as a segmented selector (the look of Enabled / Disabled / All). Same props as TabsSeeker
// and still MUI Tabs underneath, so tours that look for .MuiTab-root keep finding them.
export default function AppPageTabs({ tabs = [], ...props }) {
	return <TabsSeeker
		variant="standard"
		{...props}
		tabs={tabs.map(({ sx, iconPosition, ...tab }) => ({ ...tab, iconPosition: 'start' }))}
		stackProps={{ ...props.stackProps, sx: { alignItems: 'flex-start', mb: 2, ...props.stackProps?.sx } }}
		sx={{
			minHeight: 0,
			p: '4px',
			borderRadius: '12px',
			backgroundColor: dsColorNew.pillTrackBg,
			border: `1px solid ${dsColorNew.grayBorder}`,
			'& .MuiTabs-indicator': { display: 'none' },
			'& .MuiTabs-flexContainer': { gap: '4px', flexWrap: 'wrap' },
			'& .MuiTab-root': {
				minHeight: 0,
				minWidth: 0,
				px: '14px',
				py: '8px',
				gap: 1,
				borderRadius: '10px',
				border: '1.5px solid transparent',
				textTransform: 'none',
				fontSize: 13,
				fontWeight: 500,
				lineHeight: 1.2,
				color: dsColorNew.textMuted,
				'& .MuiTab-iconWrapper': { m: 0, fontSize: 13 },
				'&:hover': { color: dsColorNew.textDark },
				'&.Mui-selected': {
					color: dsColorNew.appBlue,
					fontWeight: 600,
					backgroundColor: dsColorNew.pillActiveBg,
					borderColor: dsColorNew.appBlue,
				},
				'&.Mui-disabled': { color: dsColorNew.textSubtle },
			},
			...props.sx,
		}}
	/>
}
